
import { Component, Provide, Vue } from 'vue-property-decorator';
import Scaffold from '@/ui/Scaffold.vue';
import { glossRepository, globalState, bookRepository, fileRepository } from '@/container';

@Component({
    components: {
        Scaffold,
    },
})
export default class App extends Vue {
    @Provide()
    public glossRepository = glossRepository;

    @Provide()
    public bookRepository = bookRepository;

    @Provide()
    public fileRepository = fileRepository;

    @Provide()
    public globalState = globalState;
}
